<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 bg-gradient-primary shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3 text-white">
                                    <div style="font-size:60px; vertical-align: baseline; display: inline">⛅ </div>  
                                    <img src="img/brand/kara-logo-handelson.png" width="90px" style="vertical-align: baseline;"/>
                                    <span>Own your health data.</span>
                                    <span>Improve medical research.</span>
                                </h1>
                                <!-- Vue component for online choice experiment -->
                                <p class="lead text-white">Kara is a decentralized health data cloud which puts patients' privacy first.</p>
                                <base-button tag="a" href="http://eepurl.com/gp-YDr" type="warning" class="mt-4">
                                        💌 Join Mailing List
                                </base-button>
                                <div class="col-md-4">
                                    <modal :show.sync="modals.modal"
                                        gradient="danger"
                                        modal-classes="modal-danger modal-dialog-centered">
                                        <h6 slot="header" class="modal-title" id="modal-title-notification">Study: Help us improve medical research!</h6>

                                        <div class="py-3 text-center">
                                            <!-- <i class="ni ni-bell-55 ni-3x"></i> -->
                                            <img src="img/theme/coin.png" class="img-fluid floating">
                                            <h4 class="heading mt-4">Question</h4>
                                            <p class="lead"><b>Would you prefer to not share your {{modals.data_type}} or share your {{modals.data_type}} {{modals.privately}} for research {{modals.payment}}?</b></p>
                                        </div>

                                        <template slot="footer">
                                            <base-button type="white"
                                                @click="this.yes">
                                                Yes, Share data</base-button>
                                            <base-button type="white"
                                                        class="ml-auto"
                                                        @click="this.no">
                                                No, don't share
                                            </base-button>
                                        </template>
                                    </modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5 text-center">
                                    <h1>⚖️</h1>
                                    <h6 class="text-primary text-uppercase">Control your data</h6>
                                    <p class="description mt-3">With Kara, you are the only one having access to your health data. Control who can use your data and for what - you determine the rules.</p>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5 text-center">
                                    <h1>🔬</h1>
                                    <h6 class="text-warning text-uppercase">Accelerate Drug Discovery</h6>
                                    <p class="description mt-3">Kara enables researchers to train their machine learning models for medical research and drug discovery - without ever revealing your data.</p>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5 text-center">
                                    <h1>💝</h1>
                                    <h6 class="text-success text-uppercase">Support your cause</h6>
                                    <p class="description mt-3">In Kara, your data has real value and we want to make sure this value gets back to you and the causes you care about - fast and transparent.</p>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
               <section class="section bg-lg" id="s_ownership">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0 floating">
                            <img v-lazy="'img/theme/privacy.png'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">⚙️ Kara's System</h4>
                                <p class="lead text-italic text-white">Learn more about the research involved to build Kara.</p>
                                <base-button tag="a" href="https://www.notion.so/ds3lab/Kara-Primer-1b5290d3205e448384c6a365d2444f61" type="primary" class="mt-4">
                                        Learn more
                                </base-button>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3>🔐 Data Ownership & Privacy</h3>
                            <p class="lead">Kara is designed with ownership and privacy in mind.</p>
                            <p>
                                Kara leverages a distributed ledger and smart contracts to transparently log all transactions on your data.
                                Smart contracts are self-enforcing and make sure that data consumers play by your rules.
                            </p>
                            <p> Kara uses trusted hardware to guarantee integrity and confidentiality for your data. 
                                Differential privacy is applied on the application level to prevent data leakage.
                            </p>
                            <a href="#" class="font-weight-bold text-primary mt-5">We build a privacy-first data cloud on smart contracts, trusted hardware and diffential privacy.</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden" id="s_clinicaltrial">
            <div class="shape shape-style-1 bg-gradient-primary shape">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div class="pl-4">
                                <h4 class="display-3 text-white">💊 Clinical Trial</h4>
                                <p class="text-white">We want raise the bar for patient ownership, privacy and security for health data. This is why we are starting a clinical trial with Stanford University in Mid 2019.</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">Improving medical research</h5>
                                    <p>
                                        AI for healthcare is limited by the fact, that the most valuable data is locked in data silos. Kara breaks up these silos and allow 
                                        researchers to train their models on data that is otherwise hidden from science - extracting value from it, while never
                                        exposing the data itself.
                                    </p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-active-40" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">Solving the last-mile problem</h5>
                                    <p>Theory is not equal to practice. We want to study what it takes to build a real-world data marketplace.
                                        The clinical study will allow us to put our focus on its most important part: How to bring value to our users.
                                    </p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-secondary" id="s_charity">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-1">
                        <img src="img/theme/coin.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-2">
                        <div class="pr-md-5">
                            <!-- <icon name="fa fa-heart" class="mb-5 bg-gradient-white" size="lg" type="primary" shadow
                                  rounded></icon> -->
                            <h3>💝 Support your cause</h3>
                            <p>Earn tokens for every AI model that trains on your data. 
                                Kara will then donate your tokens securely and transparently to a charity of your choice.
                            </p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="fa fa-rocket"></badge>
                                        <h6 class="mb-0">Fast</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Transparent</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">Auditable</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">👩‍🔬 The Team</h2>
                        <p class="lead text-muted">We are an interdisciplinary team of international researchers based in Switzerland 🇨🇭 and the U.S. 🇺🇸</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <a href="https://daviddao.org">
                                <img v-lazy="'img/people/david.jpg'"
                                    class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                    style="width: 200px;">
                            </a>
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">David Dao</span>
                                    <small class="h6 text-muted">ETH Zurich</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/ruoxi.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Ruoxi Jia</span>
                                    <small class="h6 text-muted">UC Berkeley</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/johannes.jpg'"
                                    class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                    style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Johannes Rausch</span>
                                    <small class="h6 text-muted">ETH Zurich</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/clement.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Clement Fung</span>
                                    <small class="h6 text-muted">OasisLabs</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/joe.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Prof. Joe Near</span>
                                    <small class="h6 text-muted">University of Vermont</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/ce.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Prof. Ce Zhang</span>
                                    <small class="h6 text-muted">ETH Zurich</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/robert.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Prof. Robert Chang</span>
                                    <small class="h6 text-muted">Stanford University</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/people/dawn.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Prof. Dawn Song</span>
                                    <small class="h6 text-muted">UC Berkeley / OasisLabs</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <div class="text-center">
                            <h4 class="display-4 mb-5 mt-5">🏛️ Partners</h4>
                            <div class="row justify-content-center">
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.ethz.ch/en.html" target="_blank" data-toggle="tooltip"
                                       data-original-title="ETH Zurich">
                                        <img v-lazy="'img/theme/eth.png'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.oasislabs.com/" target="_blank" data-toggle="tooltip"
                                       data-original-title="OasisLabs">
                                        <img v-lazy="'img/theme/oasis.png'"
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.berkeley.edu/" target="_blank" data-toggle="tooltip"
                                       data-original-title="UC Berkeley">
                                        <img v-lazy="'img/theme/berkeley.png'" 
                                             class="img-fluid">
                                    </a>
                                </div>
                                <div class="col-lg-2 col-4">
                                    <a href="https://www.stanford.edu/" target="_blank" data-toggle="tooltip"
                                       data-original-title="Stanford University">
                                        <img v-lazy="'img/theme/stanford.png'"
                                             class="img-fluid">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import firebase from "firebase/app";
import 'firebase/database';

var firebaseConfig = {
    apiKey: "AIzaSyB0zm4DF3S7K8dFg4rb-ZktajIWHbgaqAs",
    authDomain: "survey-e4e61.firebaseapp.com",
    databaseURL: "https://survey-e4e61.firebaseio.com",
    projectId: "survey-e4e61",
    storageBucket: "survey-e4e61.appspot.com",
    messagingSenderId: "989358228743",
    appId: "1:989358228743:web:488827e9431dba3d"
  };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default {
  name: "home",
  components: {
    Modal
  },
  methods: {
      yes: function (event) {
        this.modals.modal = false;
        let data = {
            payment: this.modals.payment, 
            data_type: this.modals.data_type,
            privately: this.modals.privately,
            yes: true
        };
        var d = new Date();
        var t = d.getTime();
        firebase.database().ref("survey/" + t).set(data);
      },
      no: function (event) {
        this.modals.modal = false;
        let data = {
            payment: this.modals.payment, 
            data_type: this.modals.data_type,
            privately: this.modals.privately,
            yes: false
        };
        var d = new Date();
        var t = d.getTime();
        firebase.database().ref("survey/" + t).set(data);
      }
  },
  data() {
    let random = Math.random();
    let payment = ["for free", "for 1$", "for 10$", "for 20$", "for 30$", "for 40$", "for 50$", "for 60$", "for 70$", "for 80$", "for 90$", "for 100$", "for 1000$"][Math.round(random * 12)];
    let data_type = ["genetic data", "medical health records", "medical X-ray data", "sexual health data"][Math.round(random * 3)];
    let privately = ["to a secure system", ""][Math.round(random)];
    return {
      modals: {
        modal: true,
        payment: payment,
        data_type: data_type,
        privately: privately
      }
    };
  }
};
</script>
